import { AbstractControl, ValidatorFn } from '@angular/forms';

const ptDatePattern =
  /^(19|20)\d{2}\-(0[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])$/g;
const stDatePattern =
  /^(0[1-9]|1\d|2\d|3[01])\-(0[1-9]|1[0-2])\-(19|20)\d{2}$/g;

export const isValidDate = (value: string): boolean => {
  // Check format YYYY-MM-DD
  const firstFormatDate = value && !value.match(ptDatePattern);

  // Check format DD-MM-YYYY Only Safari
  const secondFormatDate = value && !value.match(stDatePattern);

  return !(firstFormatDate && secondFormatDate);
};

export const dateValidator = (): ValidatorFn => {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const isValid = isValidDate(control.value);

    return isValid ? null : { dateInvalid: true };
  };
};
